import { render, staticRenderFns } from "./SuburbStories.vue?vue&type=template&id=e8e0c3c6&scoped=true"
import script from "./SuburbStories.vue?vue&type=script&lang=ts"
export * from "./SuburbStories.vue?vue&type=script&lang=ts"
import style0 from "./SuburbStories.vue?vue&type=style&index=0&id=e8e0c3c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e0c3c6",
  null
  
)

export default component.exports